import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import Avatar from "../../assets/images/four.png";
import "../../Styles/Profile.css";
import { Modal, Button, Table } from "react-bootstrap";
import { MdBlock } from "react-icons/md";
import { useParams, useNavigate } from "react-router-dom";
import { getUserById } from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import { baseURL } from "../../services/axios/eps";
import { format } from "date-fns";

function UserProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [blockDuration, setBlockDuration] = useState("One Day");

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const getUserDataById = async () => {
    const res = await getUserById(id);
    if (res?.data?.success && res?.data?.data) {
      setUserData(res.data.data);
    } else {
      handleErrors(res, navigate, "User Profile:");
    }
  };
  console.log("userData?.favoriteGames :", userData);

  useEffect(() => {
    if (id) {
      getUserDataById();
    }
  }, []);
  return (
    <DashboardLayout>
      <div>
        <div>
          <div className="row">
            <div>
              <img
                src={Avatar}
                alt=""
                className="card-img-top profile-wid-img object-fit-cover"
                style={{ height: 200 }}
              />
              <div className="position-absolute end-0 top-0 m-3"></div>
            </div>
            <div className="card-body pt-0 mt-[-2rem]">
              <div className="text-center">
                <div className="profile-user position-relative d-inline-block mx-auto">
                  <img
                    crossorigin="anonymous"
                    src={
                      userData?.image
                        ? `${baseURL}/uploads/file/${userData.image}`
                        : require("../../assets/images/t-one.png")
                    }
                    alt="Employee Avatar"
                    className="img-fluid center avatar-lg rounded-circle object-fit-cover img-thumbnail user-profile-image"
                    style={{
                      maxHeight: "200px",
                      minHeight: "150px",
                      width: "150px",
                      border: "5px solid #ccc",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div className="mt-3">
                  <h5 className="mb-0">
                    {`${userData?.first_name || ""} ${userData?.last_name || ""}`}
                    <i className="bi bi-patch-check-fill align-baseline text-info ms-1" />
                  </h5>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-12 card p-4 rounded mb-4 text-light"
              style={{ border: "none", background: "#0a1117" }}
            >
              <div className="d-flex align-items-center flex-wrap gap-2 mb-4">
                <ul
                  className="nav nav-pills arrow-navtabs nav-secondary gap-2 flex-grow-1 order-2 order-lg-1"
                  role="tablist"
                >
                  <li
                    className="nav-item"
                    role="presentation"
                    data-testid="pdTab"
                  >
                    <a
                      className="nav-link active"
                      data-bs-toggle="tab"
                      href="#personalDetails"
                      role="tab"
                      aria-selected="true"
                    >
                      Personal Details
                    </a>
                  </li>
                  <li
                    className="nav-item"
                    role="presentation"
                    data-testid="achTab"
                  >
                    <a
                      className="nav-link"
                      data-bs-toggle="tab"
                      href="#Achievements"
                      role="tab"
                      aria-selected="false"
                      tabIndex={-1}
                    >
                      Achievements &amp; Badges
                    </a>
                  </li>
                  <li
                    className="nav-item"
                    role="presentation"
                    data-testid="fgTab"
                  >
                    <a
                      className="nav-link"
                      data-bs-toggle="tab"
                      href="#FavoriteGames"
                      role="tab"
                      aria-selected="false"
                      tabIndex={-1}
                    >
                      Favorite Games
                    </a>
                  </li>
                  <li
                    className="nav-item"
                    role="presentation"
                    data-testid="othersTab"
                  >
                    <a
                      className="nav-link"
                      data-bs-toggle="tab"
                      href="#securityPrivacy"
                      role="tab"
                      aria-selected="false"
                      tabIndex={-1}
                    >
                      Others
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <div className="tab-content">
                  <div
                    className="tab-pane active"
                    id="personalDetails"
                    role="tabpanel"
                  >
                    <div className="card shadow-lg border-0 rounded-4">
                      {/* Card Header */}
                      <div className="card-header bg-dark text-white py-3">
                        <h5 className="card-title mb-0 fs-4 fw-bold">
                          Personal Details
                        </h5>
                      </div>

                      {/* Card Body */}
                      <div className="card-body bg-dark text-white">
                        <div className="row g-4">
                          {/* Reusable Field Component */}
                          {[
                            {
                              label: "User Name",
                              value: userData?.user_name || "",
                            },
                            {
                              label: "First Name",
                              value: userData?.first_name || "",
                            },
                            {
                              label: "Last Name",
                              value: userData?.last_name || "",
                            },
                            { label: "Email", value: userData?.email || "" },
                            {
                              label: "Zip Code",
                              value: userData?.zip_code || "",
                            },
                            {
                              label: "Gender",
                              value: userData?.gender || "",
                            },
                            {
                              label: "Social ID",
                              value: userData?.social_id || "",
                            },
                            {
                              label: "Signing Method",
                              value: userData?.signing_method || "",
                            },
                            {
                              label: "Status",
                              value:
                                userData?.status === 1 ? "Active" : "In-Active",
                            },
                            {
                              label: "Address Line 1",
                              value: userData?.address_line_1 || "",
                            },
                            {
                              label: "Address Line 2",
                              value: userData?.address_line_2 || "",
                            },
                            {
                              label: "Country",
                              value: userData?.country?.country_name || "",
                            },
                            {
                              label: "Province",
                              value: userData?.province?.province_name || "",
                            },
                            {
                              label: "City",
                              value: userData?.city?.city_name || "",
                            },
                          ].map((item, index) => (
                            <div className="col-lg-6" key={index}>
                              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                <span className="text-secondary fs-6 fw-semibold">
                                  {item.label}
                                </span>
                                <span
                                  className={`d-block fs-5 fw-medium ${!item.value && "text-danger"}`}
                                >
                                  {item.value || "N/A"}
                                </span>
                              </div>
                            </div>
                          ))}
                          <div className="col-lg-12">
                            <div className="p-3 bg-secondary bg-opacity-10 rounded">
                              <span className="text-secondary fs-6 fw-semibold">
                                Bio
                              </span>
                              <span
                                className={`d-block fs-5 fw-medium ${!userData?.bio && "text-danger"}`}
                              >
                                {userData?.bio || "N/A"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="tab-pane" id="Achievements" role="tabpanel">
                    <div className="card shadow-lg border-0 rounded-4">
                      <div className="card-header bg-dark text-white py-3">
                        <h6 className="card-title mb-0 fs-4 fw-bold">Badges</h6>
                      </div>
                      <div
                        className="card-body"
                        style={{
                          background: "#0d0e0e",
                          borderBottomRightRadius: "11px",
                          borderBottomLeftRadius: "11px",
                        }}
                      >
                        <div className="row g-4">
                          {userData?.badges?.length > 0 ? (
                            userData?.badges?.map((bdg, index) => (
                              <div
                                key={index}
                                className="col-lg-3 col-md-4 col-sm-6"
                              >
                                <div className="border bg-dark rounded-3 p-3 text-center shadow-lg transition-transform transform hover:scale-105 hover:border-[#00ff99] duration-300 ease-in-out">
                                  <div className="mb-4">
                                    <div>
                                      <p className="text-green-500 ">
                                        <strong>
                                          {bdg?.UserBadges?.createdAt
                                            ? format(
                                                bdg?.UserBadges?.createdAt,
                                                "MMMM"
                                              )
                                            : "N/A"}
                                        </strong>
                                      </p>
                                    </div>
                                    <img
                                      crossorigin="anonymous"
                                      src={`${baseURL}uploads/file/${bdg?.icon}`}
                                      alt="Rank Badge"
                                      className="w-24 h-24 transition-transform duration-300 hover:rotate-6"
                                      style={{ margin: "0 auto" }}
                                    />
                                  </div>

                                  <h2 className="text-white text-xl font-semibold">
                                    {bdg.name}
                                  </h2>
                                  <p className="text-gray-400 text-sm">
                                    Legendary
                                  </p>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="align-items-center justify-content-center flex">
                              <p className="text-light">No Badges yet!</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="card shadow-lg border-0 rounded-4 mb-4">
                      <div className="card-header bg-dark text-white py-3">
                        <h6 className="card-title mb-0 fs-4 fw-bold">
                          Achievements
                        </h6>
                      </div>
                      <div
                        className="card-body"
                        style={{
                          background: "#0d0e0e",
                          borderBottomRightRadius: "11px",
                          borderBottomLeftRadius: "11px",
                        }}
                      >
                        <div className="row g-4">
                          {userData?.achievements?.length > 0 ? (
                            userData.achievements.map((ach, index) => (
                              <div
                                key={index}
                                className="col-lg-3 col-md-4 col-sm-6"
                              >
                                <div className="border bg-dark rounded-3 p-3 text-center shadow-lg transition-transform transform hover:scale-105 hover:border-[#00ff99] duration-300 ease-in-out">
                                  <div className="mb-4">
                                    <div>
                                      <p className="text-green-500 ">
                                        <strong>
                                          {ach?.UsersAchievments?.createdAt
                                            ? format(
                                                ach?.UsersAchievments
                                                  ?.createdAt,
                                                "MMMM"
                                              )
                                            : "N/A"}
                                        </strong>
                                      </p>
                                    </div>
                                    <img
                                      crossorigin="anonymous"
                                      src={`${baseURL}/uploads/file/${ach?.icon}`}
                                      alt="Rank Badge"
                                      className="w-24 h-24 transition-transform duration-300 hover:rotate-6"
                                      style={{ margin: "0 auto" }}
                                    />
                                  </div>

                                  <h2 className="text-white text-xl font-semibold">
                                    {ach.name}
                                  </h2>
                                  <p className="text-gray-400 text-sm">
                                    Legendary
                                  </p>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="align-items-center justify-content-center flex">
                              <p className="text-light">No Achievements yet!</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="tab-pane" id="FavoriteGames" role="tabpanel">
                    <div
                      className="card-body"
                      style={{
                        background: "#0d0e0e",
                        BorderBottomRightRadius: "11px",
                        borderBottomLeftRadius: "11px",
                      }}
                    >
                      <div className="row g-4">
                        {userData?.favoriteGames?.length > 0 ? (
                          userData?.favoriteGames?.map((fgm) => (
                            <div className="col-lg-3 col-md-4 col-sm-6">
                              <div className="relative rounded-xl overflow-hidden bg-[#1a1d21] shadow-lg transition-all transform hover:scale-105 hover:shadow-[0_0_20px_#00ff99] duration-300 ease-in-out border border-[#00ff99]">
                                <div className="absolute inset-0 bg-gradient-to-br from-[#00ff99] to-transparent opacity-20 blur-2xl"></div>
                                <div className="relative">
                                  <img
                                    crossorigin="anonymous"
                                    src={`${baseURL}uploads/file/${fgm?.game?.icon}`}
                                    alt="/game.png"
                                    className="w-full h-48 object-cover brightness-110"
                                  />
                                </div>

                                <div className="bg-gradient-to-b from-[#00ff99] to-[#00cc77] px-5 py-4 relative text-black">
                                  <h2 className="text-black text-lg font-bold drop-shadow-md">
                                    {fgm?.game?.title || ""}
                                  </h2>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="align-items-center justify-content-center flex">
                            <p className="text-light">
                              User has no favorite games yet!
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane text-light"
                    id="securityPrivacy"
                    role="tabpanel"
                  >
                    <div className="card shadow-lg border-0 rounded-4">
                      <div className="card-header bg-dark text-white py-3">
                        {/* Card Header */}
                        <div className="card-header">
                          <h6 className="card-title mb-0">Ohters</h6>
                        </div>

                        <div className="card-body">
                          <div className="row">
                            {[
                              {
                                item: "Logged-in",
                                value:
                                  userData?.is_logged_in === 1 ? "Yes" : "No",
                              },
                              {
                                item: "Last logged-In",
                                value: userData?.last_logged_in
                                  ? format(userData?.last_logged_in, "PPpp")
                                  : "",
                              },
                              {
                                item: "Last Logged-Out",
                                value: userData?.last_logged_out
                                  ? format(userData?.last_logged_out, "PPpp")
                                  : "",
                              },
                              {
                                item: "Register From",
                                value: userData?.signing_method || "",
                              },
                              {
                                item: "Updated By",
                                value: userData?.updated_by || "",
                              },
                              {
                                item: "Created At",
                                value:
                                  (userData?.createdAt &&
                                    format(userData.createdAt, "PP")) ||
                                  "",
                              },
                              {
                                item: "Updated At",
                                value:
                                  (userData?.updatedAt &&
                                    format(userData.updatedAt, "PP")) ||
                                  "",
                              },
                              {
                                item: "Deleted At",
                                value:
                                  (userData?.deletedAt &&
                                    format(userData.deletedAt, "PP")) ||
                                  "",
                              },
                              {
                                item: "Blocked",
                                value: userData?.blocked?.some(
                                  (f) => f.deletedAt === null
                                )
                                  ? "Yes"
                                  : "No",
                              },
                            ].map((usr) => (
                              <div className="col-lg-6 mb-3">
                                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                  <span className="text-secondary fs-6 fw-semibold">
                                    {usr?.item}
                                  </span>
                                  <span
                                    className={`d-block fs-5 fw-medium ${!usr.value && "text-danger"}`}
                                  >
                                    {usr.value || "N/A"}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                            <div className="table-responsive bg-dark rouded mb-4">
                          <div className="card-header">
                            <h6 className="card-title mb-4">Block History</h6>
                              <Table
                                striped
                                // bordered
                                hover
                                variant="dark"
                                // className="mt-4"
                              >
                                <thead>
                                  <tr>
                                    <th>Reason</th>
                                    <th>Blocked For(Days)</th>
                                    <th>Blocked On</th>
                                    <th>Blocked Till</th>
                                    <th>Un-blocked On</th>
                                    <th>Blocked By</th>
                                    <th>Un-blocked By</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {userData?.blocked?.length ? (
                                    userData?.blocked?.map((item, index) => (
                                      <tr key={index}>
                                        <td>{item.reason}</td>
                                        <td>{item.blocked_for_days}</td>
                                        <td>
                                          {item?.createdAt
                                            ? format(item?.createdAt, "PP")
                                            : "--"}
                                        </td>
                                        <td>
                                          {item.blocked_till
                                            ? format(item?.blocked_till, "PP")
                                            : "--"}
                                        </td>
                                        <td>
                                          {item?.deletedAt && item.updatedAt
                                            ? format(item?.updatedAt, "PP")
                                            : "--"}
                                        </td>
                                        <td>
                                          {item?.blocked_by_emp
                                            ? `${item?.blocked_by_emp.first_name} ${item?.blocked_by_emp.last_name}`
                                            : "-"}
                                        </td>
                                        <td>
                                          {item?.unblocked_by_emp
                                            ? `${item?.unblocked_by_emp.first_name} ${item?.unblocked_by_emp.last_name}`
                                            : item?.deletedAt
                                              ? "system"
                                              : "--"}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <p className="mt-3 text-center">
                                      User does not has any block history.
                                    </p>
                                    // <p className="text-center">
                                    //   User does not has any block history.
                                    // </p>
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>Block User</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          <div className="mb-3">
            <label htmlFor="blockDuration" className="form-label">
              Block Duration:
            </label>
            <select
              id="blockDuration"
              className="form-select bg-dark text-light border-light"
              value={blockDuration}
              onChange={(e) => setBlockDuration(e.target.value)}
            >
              <option value="One Day">One Day</option>
              <option value="One Week">One Week</option>
              <option value="One Month">One Month</option>
              <option value="One Year">One Year</option>
              <option value="Permanent">Permanent</option>
            </select>
          </div>
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          <Button
            variant="secondary"
            onClick={handleCloseModal}
            className="px-4 py-2"
          >
            Close
          </Button>
          <Button
            variant="danger"
            className="d-flex align-items-center px-4 py-2"
          >
            <MdBlock className="me-2" /> Block
          </Button>
        </Modal.Footer>
      </Modal>
    </DashboardLayout>
  );
}

export default UserProfile;
